/* Free-delivery progress (snippets/lk-freeship.liquid): "Add ₹180 more for FREE delivery".
   Reads the bag total from /cart.js and refreshes whenever anything changes the bag (theme add-to-bag, GoKwik side cart,
   quantity changes), when the shopper comes back to the tab, and when the product page swaps shade (the price changes).
   Shipping is free automatically from the threshold (Settings > Shipping), so no code is involved. */
(function () {
  if (window.__lkFs) return;
  window.__lkFs = true;
  var total = null, timer = 0, busy = false, again = false;

  function els() { return document.querySelectorAll('[data-lk-fs]'); }
  function money(paise) { return '₹' + Math.ceil(paise / 100).toLocaleString('en-IN'); }
  /* price of the shade currently picked on the product page, in paise (0 elsewhere) */
  function itemPrice() {
    var el = document.querySelector('.main-product .price_block .price');
    var m = el && (el.textContent || '').match(/\d[\d,]*(\.\d+)?/);
    return m ? Math.round(parseFloat(m[0].replace(/,/g, '')) * 100) : 0;
  }
  function message(t, tot, mini) {
    var left = t - tot, ip = mini ? 0 : itemPrice();
    if (left <= 0) return '🎉 You’ve unlocked <b>FREE delivery</b>';
    if (mini) return tot > 0 ? '<b>' + money(left) + '</b> away from <b>FREE delivery</b>' : '<b>FREE delivery</b> above ' + money(t);
    if (tot === 0) return ip >= t ? 'This one ships <b>FREE</b> 🎉' : '<b>FREE delivery</b> on orders above ' + money(t) + (ip ? ' · add this + <b>' + money(t - ip) + '</b> more' : '');
    if (ip && tot + ip >= t) return 'Add this to your bag to unlock <b>FREE delivery</b> 🎉';
    return 'Add <b>' + money(left) + '</b> more for <b>FREE delivery</b>';
  }
  function render() {
    if (total === null) return;
    els().forEach(function (el) {
      var t = parseInt(el.getAttribute('data-threshold'), 10) || 100000;
      var mini = el.getAttribute('data-mode') === 'mini';
      var html = message(t, total, mini);
      var msg = el.querySelector('.lk-fs__msg'), fill = el.querySelector('.lk-fs__fill');
      if (msg && msg.innerHTML !== html) msg.innerHTML = html;
      if (fill) fill.style.width = Math.min(100, Math.round(total / t * 100)) + '%';
      el.classList.toggle('is-done', total >= t);
      if (el.hidden) el.hidden = false;
    });
  }
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c && typeof c.total_price === 'number' ? c.total_price : 0; render(); })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }
  function soon(ms) { clearTimeout(timer); timer = setTimeout(refresh, ms || 500); }
  var CART_CHANGE = /\/cart\/(add|change|update|clear)/;

  /* anything on the page that changes the bag (theme, GoKwik) goes through fetch or XHR */
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var p = of.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_CHANGE.test(u)) p.then(function () { soon(); }, function () { soon(); });
      } catch (e) {}
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (CART_CHANGE.test(String(u))) this.addEventListener('loadend', function () { soon(); }); } catch (e) {}
      return oo.apply(this, arguments);
    };
  }
  /* safety net for carts that change outside this page (another tab) */
  document.addEventListener('visibilitychange', function () { if (!document.hidden) soon(100); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) soon(100); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.add_to_cart, .lk-satc__btn, .lk-sheet__add, button[name="add"], .main-product button[class*="add-to-cart-button-"]')) { soon(1500); setTimeout(refresh, 4000); }
  }, true);
  /* product page: the theme re-renders the product section on a shade change (new price, and a fresh copy of the bar) */
  var main = document.querySelector('.main-product'), queued = false;
  if (main && window.MutationObserver) new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; render(); });
  }).observe(main, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();